import { useQuery } from 'react-query'

import { getHistoryWorkouts, HistoryDateRange } from '../api/history-workouts/getHistoryWorkouts'

export const useOwnHistoryWorkoutsQuery = (dateRange: HistoryDateRange) =>
  useQuery(['own-history-workouts', dateRange], () => getHistoryWorkouts('me', dateRange))
